(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
    constructor() {
    super();
    }

    connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' ||
    this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();

    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
    this.header.classList.add('shopify-section-header-sticky');
    };

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
    }

    setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
    this.headerBounds = entries[0].intersectionRect;
    observer.disconnect();
    });

    observer.observe(this.header);
    }

    onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
    this.header.classList.add('scrolled-past-header');
    if (this.preventHide) return;
    requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
    this.header.classList.add('scrolled-past-header');
    if (!this.preventReveal) {
    requestAnimationFrame(this.reveal.bind(this));
    } else {
    window.clearTimeout(this.isScrolling);

    this.isScrolling = setTimeout(() => {
    this.preventReveal = false;
    }, 66);

    requestAnimationFrame(this.hide.bind(this));
    }
    } else if (scrollTop <= this.headerBounds.top) {
    this.header.classList.remove('scrolled-past-header');
    requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
    }

    hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
    }

    reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
    }
    }

    customElements.define('sticky-header', StickyHeader);
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["probiotic-info"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('.probiotic-tabs [role="tab"]');
  const panels = document.querySelectorAll('.probiotic-tabs [role="tabpanel"]');

  function activateTab(tab) {
    tabs.forEach(t => {
      t.setAttribute('aria-selected', 'false');
      t.tabIndex = -1;
    });
    panels.forEach(p => {
      p.setAttribute('aria-hidden', 'true');
      p.tabIndex = -1;
    });

    tab.setAttribute('aria-selected', 'true');
    tab.tabIndex = 0;
    tab.focus();

    const panelId = tab.getAttribute('aria-controls');
    const panel = document.getElementById(panelId);
    if (panel) {
      panel.setAttribute('aria-hidden', 'false');
      panel.tabIndex = 0;
    }
  }

  tabs.forEach(tab => tab.addEventListener('click', () => activateTab(tab)));

  // Mobile accordion only for benefits
  if (window.innerWidth <= 767) {
    const cards = document.querySelectorAll('#panel-benefits .card');
    cards.forEach(card => {
      const toggle = card.querySelector('.accordion-toggle');
      const content = card.querySelector('.card-text');
      if (toggle && content) {
        toggle.addEventListener('click', () => {
          cards.forEach(c => {
            if (c !== card) collapseCard(c);
          });
          if (card.classList.contains('open')) collapseCard(card);
          else expandCard(card);
        });
      }
    });

    function expandCard(card) {
      const content = card.querySelector('.card-text');
      card.classList.add('open');
      card.querySelector('.accordion-toggle').textContent = '−';
      content.style.maxHeight = content.scrollHeight + 'px';
    }

    function collapseCard(card) {
      const content = card.querySelector('.card-text');
      card.classList.remove('open');
      card.querySelector('.accordion-toggle').textContent = '＋';
      content.style.maxHeight = '0px';
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["progress-indicator"] && !Shopify.designMode) return;
  try {
    
function setCircularProgress(el, percent) {
  const circle = el.querySelector('.progress-arc');
  const radius = circle.getAttribute('r');
  const circumference = 2 * Math.PI * radius;
  const offset = circumference * (1 - percent / 100);
  circle.style.strokeDasharray = circumference;
  circle.style.strokeDashoffset = offset;
}

function animateOnScrollOrHover() {
  document.querySelectorAll('.circular-progress-item').forEach(item => {
    const percent = parseFloat(item.dataset.percent);
    if (
      item.classList.contains('animated') ||
      item.getBoundingClientRect().top < window.innerHeight - 100
    ) {
      setCircularProgress(item, percent);
      item.classList.add('animated');
    }
    item.addEventListener('mouseenter', () => setCircularProgress(item, percent));
  });
}

document.addEventListener('DOMContentLoaded', () => {
  window.addEventListener('scroll', animateOnScrollOrHover, { passive: true });
  animateOnScrollOrHover();
});

  } catch(e) { console.error(e); }
})();
})();
